export enum Language {
  EN = 'en',
  PT = 'pt',
  ES = 'es',
  TR = 'tr',
  VI = 'vi',
}

export const PLATFORM_TOUR_VALID_LANGUAGES = [
  Language.ES,
  Language.PT,
  Language.TR,
];

export const LANGUAGE_DICT = {
  [Language.EN]: 'English',
  [Language.PT]: 'Português',
  [Language.TR]: 'Türkçe',
  [Language.ES]: 'Español',
  [Language.VI]: 'Tiêng Viêt',
};

export function isLanguageInEnum(language: string) {
  return Object.values(Language).includes(language as Language);
}

export enum CountryCodes {
  TR = 'TR',
}
